const ModalDealerTransactionDetails = () => {
    return (
        <div className='d-flex modal-transaction-inner'>
            <table>
                <tbody>
                    <tr>
                        <td>ID</td>
                        <td><span className='f-semibold'>73</span></td>
                    </tr>
                    <tr>
                        <td>Package Name</td>
                        <td><span className='f-semibold'>Kuota Iklan 10</span></td>
                    </tr>
                    <tr>
                        <td>Quota</td>
                        <td><span className='f-semibold'>10</span></td>
                    </tr>
                    <tr>
                        <td>Total Leads</td>
                        <td><span className='f-semibold'>2</span></td>
                    </tr>
                    <tr>
                        <td>Active Period</td>
                        <td><span className='f-semibold'>30 Days</span></td>
                    </tr>
                    <tr>
                        <td>SKU Type</td>
                        <td><span className='f-semibold'>Buying Listing/Featured/Bump up</span></td>
                    </tr>
                    <tr>
                        <td>Price</td>
                        <td><span className='f-semibold'>1000000</span></td>
                    </tr>
                    <tr>
                        <td>VAT (Already included in the Price)</td>
                        <td><span className='f-semibold'>28980</span></td>
                    </tr>
                    <tr>
                        <td>Discount</td>
                        <td><span className='f-semibold'>99000</span></td>
                    </tr>
                    <tr>
                        <td>Additional Discount</td>
                        <td><span className='f-semibold'>100000</span></td>
                    </tr>
                    <tr>
                        <td>Net Price</td>
                        <td><span className='f-semibold'>99000</span></td>
                    </tr>
                    <tr>
                        <td>Transaction Status</td>
                        <td><span className='f-semibold'>Success</span></td>
                    </tr>
                    <tr>
                        <td>Response</td>
                        <td><span className='f-semibold'>200. Payment Successfull</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default ModalDealerTransactionDetails;
